import instance from './requst'

export function setUserAccount(data){
    return instance.put('/v1/users/account',data)
}
export function setPassWord(data){
    return instance.put('/v1/users/password',data)
}
export function setPhone(data){
    return instance.put('/v1/users/phone',data)
}
export function addPublisher(data){
    return instance.put('/v1/users/publisher',data)
}